import athleteReducer from '@containers/SchoolPage/reducer';
import { combineReducers } from 'redux';
import layoutReducer from './layoutReducer';
import smsDispatcherReducer from './smsDispatcherReducer';

export default combineReducers({
  athleteState: athleteReducer,
  layoutState: layoutReducer,
  smsDispatcherState: smsDispatcherReducer,
})